/**
 * Enumerate possible parameters and values for column sorting
 */
export enum Column_Sort_Params {
    C = "C", // Which column to sort by
    O = "O", // How to order the values
    N = "N", // Sort the name column
    M = "M", // Sort the modified by column
    S = "S", // Sort the size column
    A = "A", // Order by ascending values
    D = "D"  // Order by descending values
}